module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SGI2xF/tc-custom/9781488000911.jpg?1726444269516",
      "alt": "This image is the cover for the book Heir to Make a Marriage, One Night With Consequences"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heir to Make a Marriage, One Night With Consequences\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A maid in Manhattan pulls the wool over a billionaire’s eyes in this “fabulous Cinderella story” from the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author (Lynne Graham).")]), _c('br'), _c('br'), _vm._v("In desperation to save her father, housekeeper Rose O’Malley thinks she can trap a man. But the second she faces Zac Valenti and the force of his palpable sensuality, she knows she can’t go through with it! "), _c('br'), _c('br'), _vm._v("Before she can call off her deception, Manhattan’s most eligible bachelor sweeps Rose off her feet—and into his bed! Stealing away like a guilty Cinderella, Rose vows never to see Zac again . . . until she discovers she’s pregnant and Zac demands his passionate betrayer and his baby remain under his control.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Abby Green\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0